/** Circular toolbar icon buttons (export, add, etc.) */
export const ACCENT_TOOLBAR_BUTTON_CLASS =
  'az-accent-toolbar-btn az-shadow disabled:az-opacity-50';

/** Loading spinner arc uses the active account theme accent */
export const THEME_SPINNER_CLASS = 'az-theme-spinner';

/** Full-screen lazy-load splash uses the active account theme */
export const THEME_SPLASH_CLASS = 'az-theme-splash';
export const THEME_SPLASH_TEXT_CLASS = 'az-theme-splash-text';
